class LunarGridBenefitLayout extends HTMLElement {
  connectedCallback() {
    this.grid = this.closest('results-list')?.querySelector('[ref="grid"]');
    if (!this.grid) return;
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this.grid);
    this.observer = new MutationObserver(this.schedule);
    this.observe();
    this.schedule();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  observe = () => this.observer.observe(this.grid, { childList: true, attributes: true, attributeFilter: ['product-grid-view'] });

  schedule = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.arrange);
  };

  arrange = () => {
    if (!this.isConnected) return;
    const original = [...this.grid.children];
    const cards = original.filter(el => el.matches('.lunar-grid-reassurance'))
      .sort((a, b) => Number(a.dataset.benefitIndex) - Number(b.dataset.benefitIndex));
    if (!cards.length) return;
    const ordered = original.filter(el => !el.matches('.lunar-grid-reassurance'));
    const desktop = window.matchMedia('(min-width: 750px)').matches && this.grid.classList.contains('product-grid--grid') && this.grid.getAttribute('product-grid-view') !== 'zoom-out';
    const columns = desktop ? getComputedStyle(this.grid).gridTemplateColumns.trim().split(/\s+/).length : 1;
    let previousSlot = -1;
    for (const card of cards) {
      const products = ordered.filter(el => el.matches('li[data-product-id]') && el.dataset.page === card.dataset.page);
      if (!products.length) continue;
      const target = Math.min(Number(card.dataset.benefitPosition), products.length);
      const side = Number(card.dataset.benefitIndex) % 2 === 1 ? columns - 1 : 0;
      let anchor = products[Math.max(0, target - 1)];
      if (desktop && columns > 1) {
        let distance = Infinity;
        for (let index = 0; index < products.length; index++) {
          const slot = ordered.indexOf(products[index]) + 1;
          if (slot <= previousSlot || slot % columns !== side) continue;
          const candidateDistance = Math.abs(index + 1 - target);
          if (candidateDistance < distance) {
            distance = candidateDistance;
            anchor = products[index];
          }
        }
      }
      const slot = ordered.indexOf(anchor) + 1;
      ordered.splice(slot, 0, card);
      previousSlot = slot;
    }
    if (ordered.length !== original.length || ordered.every((el, index) => el === original[index])) return;
    this.observer.disconnect();
    for (const card of ordered.filter(el => el.matches('.lunar-grid-reassurance')).reverse()) {
      const next = ordered[ordered.indexOf(card) + 1] || null;
      if (card.nextElementSibling !== next) this.grid.insertBefore(card, next);
    }
    this.observe();
  };
}

if (!customElements.get('lunar-grid-benefit-layout')) customElements.define('lunar-grid-benefit-layout', LunarGridBenefitLayout);
